import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConfigResponseData, GetImportState } from '../../actions/types/events/ImportEventSummaryTypes';

/**
 * Initial Event state in store
 */
const initialState: GetImportState = {
  isLoading: false,
  success: false,
  errorMessage: '',
  errorCode: '',
  config: {
    correlationId: '',
    totalRecordsCount: 0,
    totalSuccessRecordsCount: 0,
    totalFailureRecordsCount: 0,
    sourceEnv: '',
    createdBy: '',
    createdTimestamp: '',
    records: []
  }
};

/**
 * Create Event Slice to create new Event
 */
const importEventSlice = createSlice({
  name: 'importEvents',
  initialState,
  reducers: {
    importEventStarted: (state) => {
      state.isLoading = true;
    },

    importEventSuccess: (state, action: PayloadAction<ConfigResponseData>) => {
      state.isLoading = false;
      state.success = true;
      state.errorMessage = '';
      state.config = action.payload;
    },

    importEventFail: (state, action: PayloadAction<{ errorCode: string, errorMessage: string }>) => {
      state.isLoading = false;
      state.success = false;
      state.errorCode = action.payload.errorCode;
      state.errorMessage = action.payload.errorMessage;
    },

    clearImportEvent: (state,) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = '';
      state.config = initialState.config;
    }
  }
});

export const { importEventStarted, importEventSuccess, importEventFail, clearImportEvent } = importEventSlice.actions;
export default importEventSlice.reducer;
